class KravenHeaderFloatController {
  constructor() {
    this.header = document.querySelector('.header-section')
    this.desktopQuery = window.matchMedia('(min-width: 990px)')
    this.frame = 0
    this.floating = false
    this.update = this.update.bind(this)
    this.schedule = this.schedule.bind(this)
    this.bindScroller = this.bindScroller.bind(this)

    this.bindScroller()
    this.desktopQuery.addEventListener('change', this.bindScroller)
    document.addEventListener('shopify:section:load', () => {
      this.header = document.querySelector('.header-section')
      this.schedule()
    })
  }

  bindScroller() {
    this.scrollTarget?.removeEventListener('scroll', this.schedule)
    const documentScroller = document.scrollingElement || document.documentElement
    this.scroller = this.desktopQuery.matches
      ? document.querySelector('.page-wrapper') || documentScroller
      : documentScroller
    this.scrollTarget = this.desktopQuery.matches && this.scroller instanceof Element ? this.scroller : document
    this.scrollTarget.addEventListener('scroll', this.schedule, { passive: true })
    this.schedule()
  }

  schedule() {
    this.scrollTop = this.scroller?.scrollTop || 0
    if (this.frame) return
    this.frame = requestAnimationFrame(this.update)
  }

  update() {
    this.frame = 0
    this.header ||= document.querySelector('.header-section')
    if (!this.header) return

    const scrollTop = this.scrollTop || 0
    const interactionLayerOpen =
      this.header.querySelector('#Details-menu-drawer-container[open]') ||
      document.querySelector('#cart-drawer .theme-drawer__dialog[open]')

    if (!interactionLayerOpen) {
      if (!this.floating && scrollTop >= 96) this.floating = true
      if (this.floating && scrollTop <= 24) this.floating = false
    }
    if (this.header.classList.contains('kraven-header--floating') !== this.floating) {
      this.header.classList.toggle('kraven-header--floating', this.floating)
    }
  }
}

if (!window.__kravenHeaderFloatController) {
  window.__kravenHeaderFloatController = new KravenHeaderFloatController()
}
